! function() {
    "use strict";
    angular.module('webReader').factory('CustomPromiseService', constructor);
    var offset = [];
    function constructor($q){
       return{
        setValue : function(value, index){
          // console.log('set value ', value)
           offset.push(value.top);
            //  offset =  deferred.resolve(value);
            //   deferred.reject(new Error('err not found'));
            // console.log(offset)
        }  ,
        getValue: function(index){
          return offset[index];
         },
         removeValue: function(index){
          return offset.splice(index,1);
         },
         testPromise: function(){
            // return $q(function(resolve, reject) {
            //   resolve();
            //   reject(new Error('err'));
            // })?

         }
       }
    }
    constructor.$inject = ["$q"];
}();